import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000/api',
  timeout: 180000, // 3 minute timeout (for long-running AI generation requests)
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use((config) => {
  try {
    // If a share token is present in URL, attach as query parameter for GETs
    try {
      const url = new URL(window.location.href);
      const shareToken = url.searchParams.get('token');
      if (shareToken) {
        // Attach token as query param (backend accepts query token)
        const params = new URLSearchParams(config.params || {});
        params.set('token', shareToken);
        config.params = params;
      }
    } catch {}
    const token = localStorage.getItem('token');
    if (token && token !== 'undefined' && token !== 'null' && token.trim() !== '') {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      // Ensure we don't send a bogus header
      if (config.headers && config.headers.Authorization) delete config.headers.Authorization;
    }
  } catch {
    // ignore
  }
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    const status = err?.response?.status;
    if (status === 401 || status === 403) {
      // If we have a share token in URL, do not redirect to login on read-only views
      try {
        const url = new URL(window.location.href);
        if (url.searchParams.get('readonly') === '1') {
          return Promise.reject(err);
        }
      } catch {}
      try { localStorage.removeItem('token'); } catch {}
      // soft redirect without hard reload to preserve dev state
      try { if (window.location.pathname !== '/login') window.location.href = '/login'; } catch {}
    }
    return Promise.reject(err);
  }
);

export default api; 